import { useNavigate } from "react-router-dom";
import {
  BaseInvoiceBodySchema,
  DefaultService,
  InvoiceBodySchema,
} from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Camelize } from "camelize-ts";
import snakify from "snakify-ts";
import { toaster } from "../components/toaster";

export const useInvoiceCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["invoiceCreate"],
    mutationFn: (data: Camelize<InvoiceBodySchema>) => {
      return DefaultService.fakturInvoicesViewsInvoicesCreate({
        requestBody: snakify(data),
      });
    },
    onSuccess: () => {
      toaster.success({ title: "Faktura opprettet!" });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
      navigate("/invoices/");
    },
  });
};

export const useInvoiceCreateFromTemplate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["invoiceCreateFromTemplate"],
    mutationFn: ({
      templateId,
      data,
    }: {
      templateId: number;
      data: Camelize<BaseInvoiceBodySchema>;
    }) => {
      return DefaultService.fakturInvoicesViewsInvoiceFromTemplateCreate({
        templateId,
        requestBody: snakify(data),
      });
    },
    onSuccess: () => {
      toaster.success({ title: "Faktura opprettet!" });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
      navigate("/invoices/");
    },
  });
};
